import { IconButton, IconButtonProps } from '@mui/material';
import { LinkProps } from 'react-router-dom';
import { default as CloseIcon } from './assets/close.svg?react';
import { useCloseBtnStyles } from './useCloseBtnStyles';

interface CloseBtnProps
  extends IconButtonProps,
    Partial<Omit<LinkProps, keyof IconButtonProps>> {
  isAbsolute?: boolean;
}

export function CloseBtn({
  sx,
  className,
  isAbsolute = true,
  ...props
}: CloseBtnProps): JSX.Element {
  const { classes, cx } = useCloseBtnStyles({ isAbsolute });

  return (
    <IconButton
      sx={{
        top: isAbsolute ? { xs: 8, md: 16 } : undefined,
        right: isAbsolute ? { xs: 8, md: 16 } : undefined,
        ...sx,
      }}
      className={cx(classes.root, className)}
      {...props}
    >
      <CloseIcon className={classes.icon} />
    </IconButton>
  );
}
